import { render, staticRenderFns } from "./TableRequest.vue?vue&type=template&id=4e33ca7f&"
import script from "./TableRequest.vue?vue&type=script&lang=ts&"
export * from "./TableRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports